import React from "react";
import Case from "./Case";
import {dataC} from "./data";

const CaseC = () => {
  return (
    <Case data={dataC}>
      <h2>我是CASE 03</h2>
    </Case>
  )
};

export default CaseC;